import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";
import { Link } from "react-router-dom";

const toTop = () => {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

function Delivery() {
  return (
    <div className="delivery">
      <Header />

      <main>
        <section
          id="shopify-section-template--19720760099028__main"
          className="shopify-section section"
        >
          <div className="page-width page-width--narrow section--padding">
            <h1 className="main-page-title page-title h1 text-center">
              <motion-element className="inline-flex" data-motion="fade-up">
                Shipping Policy
              </motion-element>
            </h1>
            <br />
            <div className="page__content rte">
              <p className="p1">
                <strong>
                  <b>Cartnovabin</b>
                </strong>
                &nbsp;is your premier destination for Women's shoes.&nbsp;
                <span>&nbsp;</span>We carry the latest styles in
                <span>&nbsp;</span>
                womens boots &amp; booties,<span>&nbsp;</span>heels,
                <span>&nbsp;</span>
                womens sneakers,<span>&nbsp;</span>womens
                <Link onClick={toTop} to="/">
                  {" "}
                </Link>
                sandals &amp; slides, and<span>&nbsp;</span>flats.&nbsp; With
                our constantly rotating inventory of the latest styles in womens
                shoes at amazing prices, you can be sure you will stay ahead of
                latest womens footwear style trends!&nbsp;
              </p>
              <p className="p1">
                Everyone here at Cartnovabin&nbsp;prides ourselves not only on
                the quality of our designer shoe inventory, but also our
                commitment to our customers.&nbsp; We offer multiple shipping
                options ranging from&nbsp;free to expedited shipping to ensure
                your shoes arrive as quickly as you need them!
              </p>
              <p className="p1">&nbsp;</p>
              <p className="p1">
                <b>Cartnovabin&nbsp;Free Shipping</b>
              </p>
              <ul className="ul1">
                <li className="li3">
                  <span className="s1" />
                  Free Ground Shipping within the Continental United States on
                  orders&nbsp;
                </li>
                <li className="li3">
                  Alaska and Hawaii rates are calculated at checkout
                </li>
                <li className="li3">
                  <span className="s1" />
                  Orders will be shipped out within 2-4&nbsp;business days
                </li>
                <li className="li3" style={{ textAlign: "left" }}>
                  <span className="s1" />
                  Delivery takes 2-5 days on the road&nbsp;
                </li>
              </ul>
              <p>
                <strong>Cartnovabin&nbsp;International Shipping</strong>
              </p>
              <ul>
                <li>
                  We ship internationally. Customers will be required to pay for
                  duty and shipping fee and responsible for customs clearance.
                </li>
              </ul>
              <p>
                <strong>TRACKING YOUR PACKAGE</strong>
              </p>
              <p>
                We provide tracking information on all orders. You will be able
                to track your package the entire way with the shipment
                confirmation that is provided. Please make the necessary
                arrangements to be present at the time of delivery. We will not
                be responsible if packages are stolen or lost if marked as
                delivered on shipping carrier sites.
              </p>
              <p>
                We also offer shipping insurance at a small fee, you will
                receive a separate email for terms and claim procedures if your
                packages are damaged, lost or stolen during transit.&nbsp;
              </p>
              <p>
                A $9.99 return shipment fee will be applied if your package is
                returned to our facility by our provider under the same label
                for any reason such as wrong address. Shipping is not refundable
                if the address is incorrect.
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default Delivery;
